module.exports = __webpack_public_path__ + "img/tema-1-4.8d00de01.svg";